/**
 * Theme Registry & Factory
 * 
 * Zentrale Registrierung für alle Themes.
 * Ermöglicht einfaches Hinzufügen neuer Themes (z.B. "Ocean", "Forest", etc.)
 */

import { lightThemeConfig, type ThemeColors } from './light'
import { darkThemeConfig } from './dark'
import { logger } from '../utils/logger'

/**
 * Theme Definition Interface
 */
export interface ThemeDefinition {
  name: string
  colors: ThemeColors
  // Erweiterbar für weitere Theme-Eigenschaften
  [key: string]: unknown
}

/**
 * Theme Registry
 * Alle verfügbaren Themes werden hier registriert
 */
export const themeRegistry: Record<string, ThemeDefinition> = {
  light: lightThemeConfig,
  dark: darkThemeConfig,
  // Weitere Themes können hier hinzugefügt werden:
  // ocean: oceanThemeConfig,
  // forest: forestThemeConfig,
  // highContrast: highContrastThemeConfig,
}

/**
 * Gibt die Theme-Definition für einen Theme-Namen zurück
 */
export function getTheme(themeName: string): ThemeDefinition | undefined {
  return themeRegistry[themeName]
}

/**
 * Gibt alle verfügbaren Themes zurück
 */
export function getAllThemes(): ThemeDefinition[] {
  return Object.values(themeRegistry)
}

/**
 * Prüft ob ein Theme existiert
 */
export function themeExists(themeName: string): boolean {
  return themeName in themeRegistry
}

/**
 * Factory-Funktion für Theme-Wechsel
 * Kann später erweitert werden, um CSS-Variablen zu setzen oder andere Theme-Aktionen durchzuführen
 */
export function applyThemeConfig(themeName: string): void {
  const theme = getTheme(themeName)
  
  if (!theme) {
    logger.warn(`Theme "${themeName}" nicht gefunden. Verwende Standard-Theme.`)
    return
  }

  // Hier können später CSS-Variablen gesetzt werden:
  // if (typeof document !== 'undefined') {
  //   const root = document.documentElement
  //   root.style.setProperty('--theme-bg', theme.colors.background)
  //   root.style.setProperty('--theme-fg', theme.colors.foreground)
  //   // etc.
  // }
}

/**
 * Exportiert alle Theme-Namen als Array
 */
export const availableThemes = Object.keys(themeRegistry)








